/**
 * 验证门禁区间和规则时段
 */

//验证规则时段
export const validRuleTime = (intervals) => {
	//1.只有一个不验证时段
	if (intervals.length == 1) {
		return true;
	}
	// 2. 检查相邻时间段是否合法
	try{
		for (let i = 1; i < intervals.length; i++) {
			const prevEnd = intervals[i - 1][1];
			const currStart = intervals[i][0];
			if (currStart <= prevEnd) {
				return false; // 后一个开始时间 < 前一个结束时间 → 非法
			}
		}
	}catch{
		return false;
	}

	/* // 3. 检查最后一个结束时间 ≤ 第一个开始时间
	const lastEnd = times[times.length - 1][1];
	const firstStart = times[0][0];
	if (lastEnd <= firstStart) {
		return false; // 最后一个结束时间 < 第一个开始时间 → 非法
	} */
	return true; // 所有时间段都合法
};


/**
 * 检查日期区间是否重叠
 * @param {Array} rules - 所有区间集合
 * @param {Array} currentRange - 当前规则日期区间 (如 ["2025-08-12", "2025-08-15"])
 * @param {number} currentIndex - 当前规则的索引（用于跳过自身）
 * @returns {boolean} - true表示有重叠，false表示无重叠
 */
export const hasDateRangeOverlap = (rules,currentRange, currentIndex) =>{
	if (!currentRange || currentRange.length !== 2) return false;

	const [start, end] = currentRange.map(date => new Date(date));

	return rules.some((rule, index) => {
		// 跳过自身和无效数据
		if (index === currentIndex || !rule.rulesDate) return false;

		const [otherStart, otherEnd] = rule.rulesDate.map(date => new Date(date));

		// 检测四种重叠情况
		return (
			(start >= otherStart && start <= otherEnd) || // 当前开始时间在其他区间内
			(end >= otherStart && end <= otherEnd) || // 当前结束时间在其他区间内
			(start <= otherStart && end >= otherEnd) // 当前区间完全包含其他区间
		);
	});
};